import React, { useEffect } from 'react'
import PropTypes from "prop-types";
import { useConfirm } from '../../hooks/useConfirm'
import { useMessageResources } from '../../language'
import { onError } from '../shared/messages';
import { PermissionsActions, UserHasPermission } from '../../components/shared/permissionsActions'

const FolioPendingPopup = ({ error, onCancel, onConfirm }) => {
    const confirm  = useConfirm();
    const messages = useMessageResources();


    useEffect(() => {
        //validations:
        if (!error) return;

        if (UserHasPermission(PermissionsActions.AllowSetFolioAsPending)) {
            (async () => {
                if (error.ErrorCode == 12367 || error.ErrorCode == 10167 || error.ErrorCode == 12354) {
                    if (await confirm()){
                        onConfirm?.()
                    } else {
                        onCancel?.()
                    }
                }
            })();
        }
        else {
            onError(messages('NoPermissionsForThisAction'));
        }
    }, [error])
    return <div></div>
}


FolioPendingPopup.propTypes = {
    error: PropTypes.object,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func
}

export default FolioPendingPopup 